import * as styles from "./TooltipContent.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";

import type { TooltipContentProps } from "./Tooltip.types";
import { TooltipArrow } from "./TooltipArrow";
import { TooltipPortal } from "./TooltipPortal";

export function TooltipContent({
  className,
  children,
  anchor,
  side = "top",
  sideOffset = 8,
  align = "center",
  alignOffset = 0,
  arrow = true,
  variant,
  ...props
}: TooltipContentProps): JSX.Element {
  return (
    <TooltipPortal>
      <BaseTooltip.Positioner
        data-slot="tooltip-positioner"
        className={styles.positioner}
        anchor={anchor}
        side={side}
        sideOffset={sideOffset}
        align={align}
        alignOffset={alignOffset}
      >
        <BaseTooltip.Popup
          data-slot="tooltip-content"
          className={clsx(styles.popup({ variant }), className)}
          {...props}
        >
          {children}
          {arrow && <TooltipArrow />}
        </BaseTooltip.Popup>
      </BaseTooltip.Positioner>
    </TooltipPortal>
  );
}
